export default "__VITE_ASSET__CfQZtxof__"